import React, { useState } from "react";
import axios from "axios";
import { Formik } from "formik";
import toast from "react-hot-toast";

const ContactUsForm = () => {
  const submitQuery = async (values) => {
    const email = values.email;
    const name = values.name;
    const last_name = values.name;
    const phone = values.phone;
    const message = values.message;

    try {
      const res = await axios.post(
        "https://portal.ebs365.info/api/sites/3/enquiries",
        { email, name, last_name, phone, message }
      );
      const { status, data } = res;

      if (status === 200) {
        toast.success("Submitted Successfully");
      }
    } catch (error) {
      toast.error("Something went wrong ! Please try again");
    }
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          email: "",
          message: "",
          phone: "",
          name: "",
          last_name: "", // Added last name field
        }}
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = "Required";
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = "Invalid email address";
          }
          if (!values.name) {
            errors.name = "Required";
          }
          if (!values.message) {
            errors.message = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { resetForm }) => {
            console.log("test", values)
          submitQuery(values);
          resetForm();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="single-input-field">
                    <input
                      placeholder="First Name"
                      type="text"
                      name="name" // Updated to "name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="single-input-field">
                    <input
                      placeholder="Last Name"
                      type="text"
                      name="last_name" // Updated to "lastname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.last_name} // Bind it to "lastname"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="single-input-field">
                    <input
                      placeholder="Phone"
                      type="text"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.phone} // Bind it to "phone"
                      name="phone" // Updated name
                      
                    />
                  </div>
                </div>
                {/* Email */}
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="single-input-field">
                    <input
                      placeholder="Your E-mail"
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 message-input">
              <div className="single-input-field">
                <textarea
                  placeholder="Enter Your Message Here"
                  name="message"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.message} // Bind it to message
                />
              </div>
            </div>
            <div className="single-input-fieldsbtn">
              <input type="submit" value="Send Now" />
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default ContactUsForm;
